import {useSystemStore} from "~/plugins/store/system";
import {useAuthStore} from "~/plugins/store/auth";
import {useTwoFactorStore} from "~/plugins/store/two-factor";

export default defineNuxtRouteMiddleware(async (to) => {
    // check if user is not already on the two-factor page
    if (to.path === '/account/2fa-check' || to.path === '/account/2fa') {
        return;
    }

    const authStore = useAuthStore();
    const accessToken = authStore.getAccessToken();

    if (accessToken) {
        const user = authStore.getUser();
        const systemStore = useSystemStore();
        const {userAgent} = useDevice();
        const twoFactorStore = useTwoFactorStore();
        const response = await twoFactorStore.checkActiveSession(accessToken, userAgent, <string>systemStore.clientIp);
        if (response && response.is_two_factor_auth_enabled
            && response.is_two_factor_enabled_for_user
            && !response.is_active) {
            return navigateTo('/account/2fa-check?last_url=' + encodeURIComponent(to.fullPath));
        }

        // check if user has two-factor enabled, if not redirect to two-factor page setup
        if (response?.is_two_factor_auth_required && user && !response?.is_two_factor_enabled_for_user && to.path !== '/account/2fa') {
            return navigateTo(`/account/2fa?last_url=${encodeURIComponent(to.fullPath)}`);
        }
    }
});
